import React, { useContext, useReducer } from 'react'
import Avatar from '@material-ui/core/Avatar'
import Button from 'components/button/RegularButton.jsx'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Box from '@material-ui/core/Box'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import { parseJwt, UserContext } from '../../App'
import red from '@material-ui/core/colors/red'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router'
import { getApiUrl } from '../../api/api'

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       Powered by Netzwerkreferat
//     </Typography>
//   )
// }

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

function loginReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }

    case 'success':
      return {
        ...initialLoginState,
        isError: false,
        errorMessage: '',
      }

    case 'error':
      return {
        ...state,
        isError: true,
        // errorMessage: action.errorMessage.message,
        errorMessage: 'Die Login-Daten sind nicht korrekt.',
      }

    default:
      break
  }
  return state
}

const initialLoginState = {
  isError: false,
  errorMessage: '',
  username: '',
  password: '',
}

export default function Login() {
  const classes = useStyles()

  const { setUser } = useContext(UserContext)

  const hist = useHistory()

  const [state, dispatch] = useReducer(loginReducer, initialLoginState)

  const resetPasswordLink = () => hist.push('/password-reset')

  let search = useLocation().search
  let redirect
  if (search != null) redirect = search.split('=')[1]

  const submitForm = (e) => {
    e.preventDefault()

    getApiUrl()
      .post(`/authenticate`, { username: state.username, password: state.password })
      .then(function(response) {
        let token = response.data['token']
        localStorage.setItem('token', token)
        dispatch({ type: 'success' })
        setUser(parseJwt(token))
        redirect != null ? hist.push(redirect) : hist.push('/dashboard')
      })
      .catch(function(error) {
        dispatch({ type: 'error', errorMessage: error })
        console.log('Error message: ' + error)
      })
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline/>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon/>
        </Avatar>
        <Typography component="h1" variant="h5">
          Anmelden
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="email"
            autoFocus
            value={state.username}
            onChange={(e) =>
              dispatch({
                type: 'field',
                field: 'username',
                value: e.currentTarget.value,
              })
            }
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Passwort"
            type="password"
            id="password"
            autoComplete="current-password"
            value={state.password}
            onChange={(e) =>
              dispatch({
                type: 'field',
                field: 'password',
                value: e.currentTarget.value,
              })
            }
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={(e) => {
              submitForm(e)
            }}>
            Anmelden
          </Button>
        </form>
      </div>
      {state.isError ? (
        <Box mt={1} color={red}>
          <h3>{state.errorMessage}</h3>
        </Box>
      ) : null}

      <Box mt={3}>
        <div align="center">
          <a href={resetPasswordLink} onClick={resetPasswordLink}>
            {' '}
            Passwort vergessen?{' '}
          </a>
        </div>
      </Box>
    </Container>
  )
}
